import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import Link from 'next/link';


// Component
function Footer(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    //
    const handleClick = (op: string) => {
        let url = props.socialUrls[op];

        if (url) {
            window.open(url, "_blank");
        }
    }

    //
    return (
        <Box className={props.className}>
            <Box className="footer-left-logo">
                <img alt="eternal dragons logo white" src="/Eternal Dragons Logo Lowres White.png" style={{ maxWidth: "240px", marginTop: "10px", width: "100%" }} />
            </Box>

            <Box className="footer-right-cont">
                <Box className="footer-social-cont">
                    <img alt="medium logo" onClick={() => handleClick('medium')} className="footer-right-icon-cont" src="/medium-logo.png" style={{ padding: "4px", margin: "7px", background: "#555555", width: "35px", borderRadius: "20px", display: "inline-block" }} />
                    <img alt="discord logo" onClick={() => handleClick('discord')} className="footer-right-icon-cont" src="/Discord-Logo-White.svg" style={{ padding: "4px", margin: "7px", background: "#6360d1", width: "35px", height: "35px", borderRadius: "20px", display: "inline-block" }} />
                    <TwitterIcon onClick={() => handleClick('twitter')} className="footer-right-icon-cont" sx={{ color: "white", padding: "4px", margin: "7px", background: "#4d9feb", fontSize: "35px", borderRadius: "20px", display: "inline-block" }} />
                </Box>

                <Box className="footer-links-cont">
                    <Link href="/termsAndConditions"><Box className="footer-privacy-pol">Terms and Conditions</Box></Link>
                    <Link href="/privacyPolicy"><Box className="footer-privacy-pol">Privacy Policy</Box></Link>
                    <a rel="noreferrer" target="_blank" href="https://app.termly.io/document/cookie-policy/d53b462d-48e4-4c17-bed9-c2fa236cb780"><Box className="footer-privacy-pol">Cookie Policy</Box></a>
                </Box>
            </Box>
        </Box>
    );
}

// Default style!
const FooterStyled = styled(Footer)({
    background: "#262626",
    //minHeight: "120px",
    display: 'flex',
    justifyContent: "space-between",
    flexDirection: "row",
    ".footer-left-logo": {
        height: "100%",
        padding: "20px",
        fontSize: "20px"
    },
    ".footer-right-cont": {
        height: "100%",
        padding: "20px"
    },
    ".footer-right-icon-cont": {
        transition: "all .2s linear",
        cursor: "pointer",
        "&:hover": {
            transform: "scale(1.15, 1.15)"
        }
    },
    ".footer-social-cont": {
        textAlign: "end"
    },
    ".footer-links-cont": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "end"
    },
    ['@media (max-width:500px)']: {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        ".footer-right-cont": {
            padding: "0px 0px 20px 0px"
        },
        ".footer-social-cont": {
            textAlign: "center"
        },
        ".footer-links-cont": {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center"
        },
    },
    ".footer-privacy-pol": {
        color: "white",
        textAlign: "center",
        cursor: "pointer",
        padding: "4px 10px 4px 10px",
        "&:hover": {
            textDecoration: "underline"
        }
    }
});

// Export
export default FooterStyled;
